import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
import { type PagedList } from '../types/beListApi'
import { type DynamicField, type Group } from '../types/beRecipientsApi'

const endpoints = ((baseURL: string) => {
  return {
    searchGroups: (idList: number) => {
      return `${baseURL}/api/list/${idList}/groups`
    },
    getDynamicFieldsDefinition: `${baseURL}/api/fields`,
  }
})(process.env.BERECIPIENT_URL as unknown as string)

export const beRecipientsGetAllGroups = async (
  idList: number,
): Promise<PagedList<Group>> => {
  const url = endpoints.searchGroups(idList)
  const params = {
    searchBy: '',
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Id',
    orderDescending: true,
  }
  const urlWithQuery = url + '?' + encodeParams(params)
  return await apiWrapper({
    method: 'get',
    url: urlWithQuery,
  }).then((res) => res.data)
}

export const beRecipientsGetDynamicFields = async (): Promise<
  DynamicField[]
> => {
  const url = endpoints.getDynamicFieldsDefinition
  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}
